import { Chip } from "@features/atoms/Chip"
import { defineBlock, EditableText, usePostTitleEditor } from "eddev/blocks"
import { Link } from "eddev/routing"
import { motion, MotionProps } from "motion/react"
import { cn } from "@utils/tw"

export const meta: BlockMeta = {
  title: "Full Case Studies List",
  icon: "open-folder",
  tags: ["#page"],
  flags: {
    centered: false,
    // selfAnimates: true,
  },
}

export default defineBlock("case-studies/case-studies-list", (props) => {
  return (
    <div className="w-grid mx-auto pt-headerHeight gap-y-grid-margin">
      <motion.div {...boxAnims} className={cn("fullheight-box flex flex-col gap-9", boxStyles)}>
        <EditableText
          as="h1"
          store={usePostTitleEditor(props.page?.title!)}
          placeholder="Page Title"
          plainText
          disableLineBreaks
          className="type-label-l shrink-0"
        />
        <motion.div
          initial="hide"
          animate="show"
          exit="hide"
          className="flex flex-col md:overflow-auto md:h-full"
          transition={{ staggerChildren: 0.03 }}
        >
          {props.caseStudies?.map(
            (caseStudy, index) =>
              caseStudy && (
                <motion.div
                  className={cn("w-full")}
                  variants={{ hide: { opacity: 0 }, show: { opacity: 1 } }}
                  key={caseStudy.id}
                >
                  <Link href={caseStudy.uri} className="flex flex-col md:flex-row justify-between py-7 gap-4">
                    <div className="flex md:hidden">
                      <Chip>{caseStudy.caseStudyInfo?.pillar?.title}</Chip>
                    </div>
                    <p className="type-title-s md:w-5/12">{caseStudy.title}</p>
                    <div className="md:w-7/12 flex items-center gap-7">
                      <Chip className="hidden md:flex">{caseStudy.caseStudyInfo?.pillar?.title}</Chip>
                      <div
                        className="md:line-clamp-1 type-label-l opacity-60"
                        dangerouslySetInnerHTML={{ __html: caseStudy.excerpt ?? "" }}
                      />
                    </div>
                  </Link>
                </motion.div>
              ),
          )}
        </motion.div>
      </motion.div>
    </div>
  )
})

const boxStyles = cn("border border-white/20 p-5 md:p-7 rounded-lg")
const boxAnims: MotionProps = {
  variants: {
    hide: { borderColor: "rgba(255,255,255,0)", scale: 0.98 },
    show: { borderColor: "rgba(255,255,255,0.20)", scale: 1 },
  },
}
